import { isFirstPartyLink } from '@confluence/content-smartlinks/entry-points/smartLinkBatchHelpers.ts';

import type { EnhancedSmartLink } from './smartLinkTypes.ts';
import { toTraitKey } from './connectorProviders.ts';

/** Unauthorized, and ORS offered an auth provider — so connecting is actually possible. */
export const isUnconnectedThirdParty = (link: EnhancedSmartLink): boolean =>
	!isFirstPartyLink(link.url) &&
	link.access === 'unauthorized' &&
	(link.authProviders?.length ?? 0) > 0;

export type TopApp = {
	traitKey: string;
	percent: number;
};

/**
 * Apps missing from `rates` are skipped rather than ranked at zero: absence means the org
 * has never connected that app, which is not worth advertising.
 */
export const pickTopUnconnectedApp = (
	rates: Record<string, number> | undefined,
	unconnectedTraitKeys: Set<string>,
): TopApp | undefined => {
	if (!rates) {
		return undefined;
	}

	let best: TopApp | undefined;
	for (const [traitKey, percent] of Object.entries(rates)) {
		if (!unconnectedTraitKeys.has(traitKey)) {
			continue;
		}
		if (!best || percent > best.percent) {
			best = { traitKey, percent };
		}
	}
	return best;
};

export const collectUnconnectedTraitKeys = (links: EnhancedSmartLink[]): Set<string> => {
	const traitKeys = new Set<string>();
	for (const link of links) {
		const traitKey = toTraitKey(link.key);
		if (traitKey) {
			traitKeys.add(traitKey);
		}
	}
	return traitKeys;
};
